module.exports = __webpack_public_path__ + "bea28c703f208a3a8686b4f7e70e0830.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_small_x1/public/team/Leadership_AlexP_0.jpg
// module id = 433
// module chunks = 0